import {
  GET_USER_ALL,
  PENDING_USERS,
  GET_USER_TYPES,
  CLEAR_ALL_USERS,
  GET_USER_BY_CODE,
  CLEAR_USER_BY_CODE,
  CLEAR_PENDING_USERS,
  GET_USER_DEFAULT_MODULES,
  GET_HOLIDAYS_BY_COUNTRY,
  HANDLE_WORKING_HOURS,
} from "../constants/constants";

const initialSessionState = {
  users: [],
  user: {},
  holiday: {},
  pending: [],
  userTypes: [],
  modulo: [],
  billProcessing: {
    isWithinWorkingHours: true,
    holidayStatusOk: true,
  },
};

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case PENDING_USERS:
      return {
        ...state,
        pending: [...action.users.content],
        pendingElements: action.users.totalElements,
      };
    case CLEAR_PENDING_USERS:
      return {
        ...state,
        pending: [],
        pendingElements: 0,
      };
    case GET_USER_DEFAULT_MODULES:
      return {
        ...state,
        modulo: [...action.modulo],
      };
    case GET_USER_BY_CODE:
      return {
        ...state,
        user: action.user,
      };
    case CLEAR_USER_BY_CODE:
      return {
        ...state,
        user: {},
      };
    case GET_USER_ALL:
      return {
        ...state,
        users: [...action.users.content],
        totalElements: action.users.totalElements,
      };
    case GET_USER_TYPES:
      return {
        ...state,
        userTypes: [...action.userTypes.content],
      };
    case CLEAR_ALL_USERS:
      return {
        ...state,
        users: [],
        totalElements: 0,
      };
    case GET_HOLIDAYS_BY_COUNTRY:
      return {
        ...state,
        holiday: { ...action?.data },
      };
    case HANDLE_WORKING_HOURS:
      return {
        ...state,
        billProcessing: {
          isWithinWorkingHours: action?.billProcessing.isWithinWorkingHours,
          holidayStatusOk: action?.billProcessing.holidayStatusOk,
        },
      };
    default:
      return state;
  }
};

export const getPendingUsers = (state) => state.userReducer.pending;
export const getTotalPendingUsers = (state) =>
  state.userReducer.pendingElements;
export const getAllUsers = (state) => state.userReducer.users;
export const getTotalUsers = (state) => state.userReducer.totalElements;
export const getUserByCode = (state) => state.userReducer.user;
export const getUserTypes = (state) => state.userReducer.userTypes;
export const getUserDefaultModules = (state) => state.userReducer.modulo;
export const getHolidaysByCountry = (state) => state.userReducer?.holiday;
export const getisWithinWorkingHours = (state) =>
  state.userReducer?.billProcessing.isWithinWorkingHours;
export const getHolidayStatus = (state) =>
  state.userReducer?.billProcessing.holidayStatusOk;
